import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import SelectFormInput from "../../../../models/SelectFormInput";
import { OrderForm } from "../order-form/order-form";

@Component({
  selector: "recertification-order-form",
  templateUrl: "recertification-order-form.html",
})
export class RecertificationOrderFormComponent
  extends OrderForm
  implements OnInit
{
  protected orderForm: FormGroup;
  protected incomingData;
  private textAreaMaxLength = 500;

  @Input() patientName: string;
  @Input() physicianOptions: SelectFormInput[] = [];
  @Input() physicianOrderOptions: SelectFormInput[] = [];
  @Input() status: any;
  @Output() onValidityChange: EventEmitter<any> = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {
    super();

    this.orderForm = this.formBuilder.group({
      recertificationFor: [true], //TODO default to true, but the validity of the form isn't being detected immediately when setting type to recert
      certifyingPhysician: [""],
      attendingPhysician: [""],
      sameAsCertifying: [false],
      physicianOrder: ["", Validators.compose([Validators.required])],
      physicianOrderNotes: [
        "",
        Validators.compose([Validators.maxLength(this.textAreaMaxLength / 2)]),
      ],
    });

    this.orderForm.valueChanges.subscribe((data) => {
      console.log(data, this.orderForm.valid);
      let allData = data;
      allData.attendingPhysician =
        this.orderForm.controls["attendingPhysician"].value;
      this.onValidityChange.emit({
        validity: this.orderForm.valid,
        data: allData,
      });
    });

    this.orderForm.controls["sameAsCertifying"].valueChanges.subscribe(
      (data) => {
        if (data === true) {
          this.orderForm.controls["attendingPhysician"].disable();
          if (this.orderForm.controls["certifyingPhysician"].value) {
            let physician =
              this.orderForm.controls["certifyingPhysician"].value;
            this.orderForm.controls["attendingPhysician"].setValue(physician);
          }
        } else {
          this.orderForm.controls["attendingPhysician"].enable();
        }
      }
    );

    //enforce character limit
    this.orderForm.controls["physicianOrderNotes"].valueChanges.subscribe(
      (data) => {
        if (data.length > this.textAreaMaxLength / 2) {
          this.orderForm.controls["physicianOrderNotes"].setValue(
            data.substring(0, this.textAreaMaxLength / 2)
          );
        }
      }
    );

    this.orderForm.controls["certifyingPhysician"].valueChanges.subscribe(
      (data) => {
        console.log("cert phys set", data);
        if (this.orderForm.controls["sameAsCertifying"].value) {
          this.orderForm.controls["attendingPhysician"].setValue(data);
        }
      }
    );

    this.orderForm.controls["attendingPhysician"].valueChanges.subscribe(
      (data) => {
        console.log("attending update", data);
      }
    );
  }

  ngOnInit() {
    // if discontinue add itemDiscontinue feild
    if (this.status === "discontinue") {
      this.orderForm.addControl(
        "itemDiscontinueDatetime",
        new FormControl("", Validators.required)
      );
      this.orderForm.addControl("dcPhysician", new FormControl(""));
      this.orderForm.controls["dcPhysician"].setValue(
        this.incomingData["physician"]
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/forms/recertification-order-form/recertification-order-form.ts